import clsx from 'clsx'
import {FormikProps} from 'formik'
import {FC, ChangeEvent} from 'react'

type Props = {
  className?: string
  labelClassName?: string
  label?: string
  required?: boolean
  formik: FormikProps<any>
  name: string
  disabled?: boolean
  showStatusText?: boolean
  activeText?: string
  inactiveText?: string
  onChange?: (checked: boolean) => void
}

const SwitchFormik: FC<Props> = ({
  className,
  labelClassName,
  label,
  required = false,
  formik,
  name,
  disabled = false,
  showStatusText = false,
  activeText = 'Active',
  inactiveText = 'Inactive',
  onChange,
}) => {
  const fieldProps = formik.getFieldProps(name)
  const isChecked = fieldProps.value === 1 || fieldProps.value === true

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked
    const value = checked ? 1 : 0
    formik.setFieldValue(name, value)
    onChange?.(checked)
  }

  return (
    <>
      {label && <label className={clsx('form-label', labelClassName, {required})}>{label}</label>}
      <div className={clsx('d-flex align-items-center', className)}>
        <div className='form-check form-switch'>
          <input
            type='checkbox'
            className={clsx('form-check-input cursor-pointer', {
              'cursor-no-drop': disabled,
            })}
            checked={isChecked}
            disabled={disabled}
            onChange={handleChange}
            name={name}
          />
        </div>
        {showStatusText && (
          <span className='ms-3 fw-bold text-gray-700'>
            {isChecked ? activeText : inactiveText}
          </span>
        )}
      </div>
    </>
  )
}

export {SwitchFormik}
